import { createSelector } from 'reselect';
import { parentFolderIdSelector } from 'app/Page/selectors';
import treeSelector from './tree';

const DEFAULT = {};

export default createSelector(
  treeSelector,
  parentFolderIdSelector,
  (tree, parentFolderId) => tree[parentFolderId] || DEFAULT
);
